import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  auth: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    storeAuth: (state, { payload }) => {
      state.auth = payload;
    },
  },
});

export const { storeAuth } = authSlice.actions;

export default authSlice.reducer;
